import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import { connect } from 'react-redux';
import {
  Button,
  CloseIcon,
  ContentContainer,
  FreightButton,
  HeaderContainer,
  HeaderSubText,
  HeaderText,
  WindowContainer,
} from './css';
import SalesForceChat from './SalesForceChat';
import { CLOSE_CHAT_WINDOW } from './actions';
import { Locales, SalesforceChatLanguages } from '../../../utils/enums';

const ChatWindow = (props) => {
  const { chatWindow, closeChatWindow } = props;

  if (!chatWindow.isOpen) {
    return null;
  }

  return (
    <WindowContainer>
      <HeaderContainer>
        <HeaderText field={t('ChatWithUs')} />
        <HeaderSubText field={t('ChatHours')} />
        <CloseIcon onClick={() => closeChatWindow()} />
      </HeaderContainer>
      <ContentContainer>
        <ContentContainer>
          <FreightButton
            onClick={() => {
              SalesForceChat().showChatWindow(
                window.location.pathname.toLowerCase().includes(`/${Locales.French.toLowerCase()}/`)
                  ? SalesforceChatLanguages.French
                  : SalesforceChatLanguages.English,
              );
              closeChatWindow();
            }}
          >
            {t('LtlTruckload')}
          </FreightButton>
          <Button
            onClick={() => {
              SalesForceChat().showChatWindow(
                window.location.pathname.toLowerCase().includes(`/${Locales.French.toLowerCase()}/`)
                  ? SalesforceChatLanguages.French
                  : SalesforceChatLanguages.English,
              );
              closeChatWindow();
            }}
          >
            {t('CommerceSolutions')}
          </Button>
        </ContentContainer>
      </ContentContainer>
    </WindowContainer>
  );
};

ChatWindow.propTypes = {
  chatWindow: PropTypes.shape({
    isOpen: PropTypes.bool,
  }),
  closeChatWindow: PropTypes.func,
};

const mapStateToProps = (state) => ({
  chatWindow: state.chatWindow,
});

const mapDispatchToProps = (dispatch) => ({
  closeChatWindow: () => dispatch({ type: CLOSE_CHAT_WINDOW }),
});

export default connect(mapStateToProps, mapDispatchToProps)(ChatWindow);
